import $ from 'jquery';
import '../popover/popover';

const headerPopovers = '.header__button-compare, .header__button-basket, .header__button-menu';
let counter;

$(headerPopovers)
	.popover({
		appearance: 'tab',
		trigger: 'manual',
		template: '<div class="popover popover_theme_sticker"><div class="popover__content"></div></div>',
		html: true,
		tether: {
			attachment: 'top right',
			targetAttachment: 'bottom left',
			targetOffset: '0 100%'
		},
		constraints: [{
			to: 'scrollParent',
			pin: ['left', 'right']
		}],
		content() {
			return $($(this).attr('data-target')).html();
		},
		offset: '0 -10',
		modifiers() {
			return $(this).is('.header__button-menu .button') ? 'popover_size_l' : 'popover_size_m';
		}
	}).on('mouseenter', function () {
		if ($(this).is('[aria-describedby]')) {return;}
		$(headerPopovers).not($(this)).popover('hide');
		clearTimeout(counter);
		counter = setTimeout(() => {
			$(this).popover('show');
			$('.popover, [aria-describedby]').on('mouseleave', event => {
				const $popover = $(this).data()['bs.popover'].tip;
				if (!$(event.relatedTarget).closest($popover).length && !$(event.relatedTarget).closest($(this)).length) {
					$(this).popover('hide');
				}
			});
		}, 100);
	});



/** WEBPACK FOOTER **
 ** ./app/blocks/header/header.js
 **/